export default __webpack_public_path__ + "static/media/13-IHeart.8763e378.png";